import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

interface GuideSection {
  id: string;
  title: string;
  icon: string;
}

@Component({
  selector: 'app-user-guide-dialog',
  templateUrl: './user-guide-dialog.component.html',
  styleUrls: ['./user-guide-dialog.component.css']
})
export class UserGuideDialogComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Output() closed = new EventEmitter<void>();

  activeSection: string = 'welcome';

  sections: GuideSection[] = [
    { id: 'welcome', title: 'Welcome', icon: 'waving_hand' },
    { id: 'logging-in', title: 'Logging In', icon: 'login' },
    { id: 'home-page', title: 'Home Page', icon: 'home' },
    { id: 'navigation', title: 'Navigation', icon: 'menu' },
    { id: 'message-center', title: 'Message Center', icon: 'chat' },
    { id: 'address-book', title: 'Address Book', icon: 'contacts' },
    { id: 'threads', title: 'Threads (Tickets)', icon: 'confirmation_number' },
    { id: 'profile', title: 'Profile', icon: 'person' },
    { id: 'feedback', title: 'Feedback', icon: 'feedback' },
    { id: 'notifications', title: 'Notifications', icon: 'notifications' },
    { id: 'glossary', title: 'Glossary', icon: 'menu_book' },
    { id: 'faq', title: 'FAQ', icon: 'help' }
  ];

  sidebarOpen: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  close(): void {
    this.sidebarOpen = false;
    this.closed.emit();
  }

  navigateTo(sectionId: string): void {
    this.activeSection = sectionId;
    this.sidebarOpen = false;
    const el = document.getElementById('guide-section-' + sectionId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  onBackdropClick(): void {
    this.close();
  }

  onDialogClick(event: Event): void {
    event.stopPropagation();
  }
}
